import React from 'react'
import s from './styles/MessagesPage.module.scss'
import { useMessagesPage } from './hooks/useMessagesPage'
import { UserListMessage } from '../../widgets/UserListMessage/UserListMessage'
import { ChatMessage } from '../../widgets/ChatMessage/ChatMessage'
import { MessageStudentInfo } from '../../widgets/MessageStudentInfo/MessageStudentInfo'
import { useIsMobileLg } from '../../shared/hooks/useBreakpoint'

export const MessagesPage = () => {
	const {
		users,
		selectedUser,
		messages,
		newMessage,
		setNewMessage,
		handleSend,
		activeBlock,
		checkUserHandle,
		onBackToLList,
		markAsRead,
		isStudentInfoCollapsed,
		toggleStudentInfo,
		isLoadingUsers,
		isLoadingMessages,
	} = useMessagesPage()

	const isMobileLg = useIsMobileLg()

	const showList = (isMobileLg && activeBlock === 'list') || !isMobileLg
	const showChat = (isMobileLg && activeBlock === 'message') || !isMobileLg
	const showStudentInfo =
		(isMobileLg && activeBlock === 'student') ||
		(!isMobileLg && !isStudentInfoCollapsed && selectedUser?.studentId)

	return (
		<div className={s.wrap}>
			{showList && (
				<UserListMessage
					users={users}
					checkUserHandle={checkUserHandle}
					selectedId={selectedUser?.id}
					isLoading={isLoadingUsers}
				/>
			)}
			{showChat && (
				<div className={s.panelChat}>
					<ChatMessage
						selectedUser={selectedUser}
						messages={messages}
						isLoadingMessages={isLoadingMessages}
						setNewMessage={setNewMessage}
						handleSend={handleSend}
						newMessage={newMessage}
						onBack={onBackToLList}
						onMarkAsRead={markAsRead}
						isStudentInfoCollapsed={isStudentInfoCollapsed}
						onToggleStudentInfo={toggleStudentInfo}
					/>
				</div>
			)}
			{showStudentInfo && (
				<div className={s.panelStudentInfo}>
					<MessageStudentInfo
						studentId={selectedUser.studentId}
						isCollapsed={isMobileLg ? false : isStudentInfoCollapsed}
						onCollapse={toggleStudentInfo}
					/>
				</div>
			)}
		</div>
	)
}
